module.exports = __webpack_public_path__ + "img/close-circle.62cbd693.svg";